import { createSlice } from '@reduxjs/toolkit';

import { StreamModel } from '../../../models';

export type CurrentRadioSliceState = {
  currentRadio: StreamModel;
  isHD: boolean;
  radioMode: boolean;
};

const initialState: CurrentRadioSliceState = {
  currentRadio: {
    id: 0,
    logoappfield: '',
    nomFlux: '',
    typeTitrage: '',
    urlFlux: '',
    urlFluxBD: '',
    urlFluxHD: '',
    idradio: 0,
  },
  isHD: true,
  radioMode: true,
};

const currentRadioSlice = createSlice({
  name: 'currentRadio',
  initialState,
  reducers: {
    updateCurrentRadio(state, action) {
      state.currentRadio = action.payload;
    },
    updateIsHD(state, action) {
      state.isHD = action.payload;
    },
    updateRadioMode(state, action) {
      state.radioMode = action.payload;
    },
  },
});
export const { updateCurrentRadio, updateIsHD, updateRadioMode } =
  currentRadioSlice.actions;
export const currentRadioReducer = currentRadioSlice.reducer;
